/**
 * Centralized A/B Test Configuration
 *
 * This file contains all A/B test configurations for easy management
 * and centralized control of feature rollouts.
 */

export const AB_TEST_CONFIG = {
  CONTACT_SALES: {
    enabled: true,
    rolloutPercentage: 50, // 50% of users (even recruiter IDs)
    feature: "CONTACT_SALES",
    description: "New contact sales form with improved UX"
  },
  PLAN_SELECTION_SALES_CONTACT: {
    enabled: true,
    rolloutPercentage: 20, // 20% see SalesContactCard, 80% see SalesContact
    feature: "PLAN_SELECTION_SALES_CONTACT",
    description: "Sales contact placement: 20% in card, 80% below cards"
  }

  // Future A/B tests can be added here
  // Example configuration for future A/B tests:
  //
  // NEW_FEATURE_TEST: {
  //   enabled: false,
  //   rolloutPercentage: 25,
  //   feature: 'NEW_FEATURE_V2',
  //   description: 'Testing new feature implementation',
  // }
};

export default AB_TEST_CONFIG;
